import React, { useContext, useEffect, useState, useRef } from 'react';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Context } from '.';
import AppRoutes from './AppRoutes';
import AppWrapper from './components/AppWrapper';
import MainLayout from './components/MainLayout';
import './custom.css';
import wsService from './services/WebSocketService';
import { Console } from 'console';

const App: FC = () => {

//     const [messages, setMessages] = useState([]);
//   const socketRef = useRef(null);

    const { store } = useContext(Context);

    useEffect(() => {
        if (localStorage.getItem('token')) {
            store.checkAuth();
        }
       console.log(wsService.isConnected());

        if (!wsService.isConnected()){
            wsService.connect();
        }
    }, []);
//       useEffect(() => {
//     // Создаем WebSocket соединение
//     const socket = new WebSocket('wss://localhost:44496/ws');
//     socketRef.current = socket;

//     // Обработчики событий
//     socket.onopen = () => {
//       console.log('WebSocket connected');
//     };

//     socket.onmessage = (event) => {
//       const message = JSON.parse(event.data);
//       setMessages(prev => [...prev, message]);
//     };

//     socket.onerror = (error) => {
//       console.error('WebSocket error:', error);
//     };

//     socket.onclose = () => {
//       console.log('WebSocket disconnected');
//     };

//     // Cleanup функция - закрываем соединение при размонтировании
//     return () => {
//       socket.close();
//     };
//   }, []); // Пустой массив зависимостей - запускается только при монтировании

    return (
        <AppWrapper>
            <MainLayout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            </MainLayout>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover={false }
                theme="dark" />
        </AppWrapper>)
}

export default App;

